import React from "react"
import { graphql } from 'gatsby'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Newsletter from "../components/newsletter"
import Banner from "../components/banner"

const ChiSiamoPage = ({ pageContext: { locale }, data: { chiSiamoYaml: {title, text} } }) => {
  return (
    <Layout locale={locale}>
      <SEO title="chi-siamo" />
      <div className="event-wrapper">
        <section id="chi-siamo" className="section chi-siamo" aria-labelledby="region-chi-siamo">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                <h1 id="region-chi-siamo" className="section__title">{title}</h1>
                <div dangerouslySetInnerHTML={{ __html: text }}></div>
              </div>
            </div>
          </div>
        </section>
        <Newsletter />
        <Banner />
      </div>
    </Layout>
  )
};

export default ChiSiamoPage;

export const query = graphql`
query ChiSiamoQuery($locale: String!){
  chiSiamoYaml(lang: {eq: $locale}){
    title
    text
  }
}`;
